import TitleComponent from "./TitleComponent"
import InfoComponent from "./InfoComponent"
import ChiLinksComponent from "./ChiLinksComponent"
import FormComponent from "./FormComponent"


export default function MainComponent() {
    return (
        <div className="main">
            <TitleComponent></TitleComponent>
            <InfoComponent></InfoComponent>
            <ChiLinksComponent></ChiLinksComponent>
            <FormComponent></FormComponent>
        </div>
    )


}
